import BaseAudienceOperationDataSource from "./BaseAudienceOperationDataSource";
class FileAssetAudienceOperationDataSource extends BaseAudienceOperationDataSource {
    constructor(dataSource) {
        super(dataSource);
    }
}
FileAssetAudienceOperationDataSource.TYPE = "FILE_ASSET";
export default FileAssetAudienceOperationDataSource;
